import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-faq',
  standalone: false, 
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css'
})
export class FaqComponent {
faqs = [
    {
      question: 'How to submit a new application?',
      answer: `To apply for a new permit, click on the 'Apply for Permit' tab on the lefthand side of this page and then choose the department to find the application you want to submit.`,
      open: true
    },
    {
      question: 'Where can I find the permit I need?',
      answer: 'You can browse permits by category under the "Permit Catalog" section.',
      open: false
    },
    {
      question: 'Can I get a permit in person?',
      answer: 'Yes, visit your local office during business hours.',
      open: false
    },
    {
      question: 'How do I download old permits?',
      answer: 'Log in to your account and go to "My Permits" to download previous applications.',
      open: false
    },
    {
      question: 'How do I pay my application fees?',
      answer: 'Use the "Payments" tab and follow the instructions for online payment.',
      open: false
    }
  ];

 toggle(index: number) {
    this.faqs.forEach((faq, i) => {
      if (i === index) {
        faq.open = !faq.open;
      } else {
        faq.open = false;
      }
    });
  }


}
